import {usePlatformService} from '@/di/di.root-container.hooks';

import {PropsWithChildren} from 'react';

import {ProjectFontFamily} from '@/constants';
import {useFontLoader} from '@/ui/hooks/useFontLoader';
import {LoaderPageMb} from '@/ui/pages/mb/LoaderPageMb/LoaderPageMb';
import {LoaderPageWeb} from '@/ui/pages/web/LoaderPageWeb/LoaderPageWeb';

export function FontLoaderGuard({children}: PropsWithChildren<unknown>): JSX.Element {
  const platformService = usePlatformService();
  const isMb = platformService.isMb();

  const isFontLoaderTTFirsMedium = useFontLoader({fontName: ProjectFontFamily.TTFirsMedium});
  const isFontLoaderTTFirsDemiBold = useFontLoader({fontName: ProjectFontFamily.TTFirsDemiBold});
  const isFontLoaderTTFirsDemiNormal = useFontLoader({fontName: ProjectFontFamily.TTFirsNormal});

  if (isFontLoaderTTFirsMedium && isFontLoaderTTFirsDemiBold && isFontLoaderTTFirsDemiNormal) {
    return <>{children}</>;
  }

  if (isMb) {
    return <LoaderPageMb />;
  }

  return <LoaderPageWeb />;
}
